import { t } from '../../copy'
import type { WorkItemNode } from './panels'
import type { ItemState } from './session-state'

export function isDoneRun(state: ItemState | null): boolean {
  return state === 'done'
}

export function isTerminalRun(state: ItemState | null): boolean {
  return state === 'done' || state === 'fail' || state === 'closed'
}

export function mayCancelRun(state: ItemState | null): boolean {
  return !isTerminalRun(state)
}

export interface WorkflowRunSummary {
  readonly title: string
  readonly phaseCount: number
  readonly agentCount: number
  readonly doneCount: number
  readonly activeCount: number
}

/**
 * 当前后端还没有独立 WorkflowRun 资源，因此把一份 workboard snapshot
 * 如实投影成「这轮工作」。阶段来自 work item，Agent 数只来自真实 subrun。
 */
export function buildWorkflowRunSummary(items: readonly WorkItemNode[]): WorkflowRunSummary {
  const runs = items.flatMap((item) => item.subRuns)
  const activePhase = items.find((item) => !isTerminalRun(item.state)) ?? items[0]
  return {
    title: activePhase?.name ?? t('lulu_workbench.run.summary.default_title'),
    phaseCount: items.length,
    agentCount: runs.length,
    doneCount: runs.filter((run) => isDoneRun(run.state)).length,
    activeCount: runs.filter((run) => !isTerminalRun(run.state)).length,
  }
}
